import React, { useEffect, useState } from 'react';
import CreatePOSDeviceModal from '../component/pos-device/CreatePOSDeviceModal';
import POSDeviceListTable from '../component/pos-device/POSDeviceListTable';
import { POSDeviceResponse } from '../model/POS-device.model';
import POSDeviceService from '../service/pos-device-service/POS-device.service';
import { Spinner, TextField } from '@radix-ui/themes';
import { Row, Col, Space, Select } from 'antd';

const POSDevicePage: React.FC = () => {
  const [posDeviceList, setPOSDeviceList] = useState<POSDeviceResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState<string>('');

  const fetchPOSDeviceList = async () => {
    try {
      setLoading(true);
      const data = await POSDeviceService.getPOSDeviceList();
      setPOSDeviceList(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching POS device list:', error);
    }
  };

  useEffect(() => {
    fetchPOSDeviceList();
  }, []);

  const filteredPOSDevices = posDeviceList.filter((device) => {
    const matchSearch = device.deviceCode
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchStatus = !statusFilter || device.status === statusFilter;
    return matchSearch && matchStatus;
  });

  return (
    <div className="p-2 sm:p-4 max-h-screen">
      <Row gutter={[16, 16]} className="mb-4">
        <Col
          xs={24}
          sm={12}
          md={8}
          className="flex flex-col sm:flex-row gap-2"
        >
          <Space className="w-full sm:w-auto">
            <CreatePOSDeviceModal onSuccess={fetchPOSDeviceList} />
            {/* <ExportPOSDevicesButton className="w-full sm:w-auto" /> */}
          </Space>
        </Col>
        <Col xs={24} sm={12} md={8}>
          <TextField.Root
            placeholder="Tìm kiếm theo mã thiết bị"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full"
          />
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Select
            placeholder="Lọc theo trạng thái"
            allowClear
            value={statusFilter || undefined}
            onChange={(v) => setStatusFilter(v ?? '')}
            style={{ width: '100%', minWidth: 180 }}
            options={[
              { value: '', label: 'Tất cả trạng thái' },
              { value: 'ACTIVE', label: 'Hoạt động' },
              { value: 'INACTIVE', label: 'Không hoạt động' },
            ]}
          />
        </Col>
      </Row>
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <Spinner />
        </div>
      ) : (
        <div className="overflow-x-auto">
          <POSDeviceListTable
            posDeviceList={filteredPOSDevices}
            onSuccess={fetchPOSDeviceList}
          />
        </div>
      )}
    </div>
  );
};

export default POSDevicePage;
